<template>
    <div class="dataloggerManage">
        <div v-if="$store.state.device.UsrPermission == 1" style="display: flex;flex: 1;" class="">
            <div class="section">
                <div class="search">
                    <div style="display:flex;justify-content:flex-end;align-items:center;">
                        <el-button class="button button-solid" @click.stop="showSearchBtn">
                            <i class="el-icon-search"></i>
                        </el-button>
                        <div class="search-alert" v-show="showSearch">
                            <div class="searchDiv">
                                <el-input class="searchAll" ref="iptFocus" v-model.trim="search.roleName"
                                    @keyup.enter.native="getProjectList(true)" :placeholder="$t('account.Ple_role2')" clearable>
                                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                </el-input>
                                <!-- 搜索 -->
                                <span class="search-device" @click="getProjectList(true)">{{ $t('recharge.Search') }}</span>
                                <!-- 取消 -->
                                <span class="search-hide" @click="closeSearch">{{ $t('rate.cancel') }}</span>
                            </div>
                        </div>
                        <button type="button" class="button-upload" @click="addRolePermission">
                            {{ $t('account.Add_role') }}
                            <i class="iconfont icon-biaogegongneng_xinjian"></i>
                        </button>
                    </div>
                </div>
                <el-table :data="proList" stripe border height="100%" v-loading="loadingAuthority"
                    :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }"
                    element-loading-spinner="el-icon-loading" class="tablemain tableloding"
                    :empty-text="$t('account.nodata')" ref="multipleProTable">
                    <el-table-column min-width="140px;" fixed prop="roleId" :show-overflow-tooltip="true" :label="$t('account.Role_id')">
                    </el-table-column>
                    <el-table-column prop="roleName" min-width="135px;" :show-overflow-tooltip="true"
                        :label="$t('account.accountRole')"></el-table-column>
                    <el-table-column prop="desc" min-width="135px;" :show-overflow-tooltip="true"
                        :label="$t('datalogger.describe')"></el-table-column>

                    <el-table-column prop="gts" min-width="135px;" :show-overflow-tooltip="true"
                        :label="$t('account.createTime')"></el-table-column>
                    <el-table-column :label="this.$t('datalogger.Operation')" width="100" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" class="operation" :title="$t('datalogger.edit')"
                                @click="editRole(scope.row)">
                                <i class="iconfont icon-bianji"></i>
                            </el-button>
                            <el-button type="text" class="operation" :title="$t('account.Delete')"
                                @click="deteleRole(scope.row)">
                                <i class="iconfont icon-caozuo_shanchu"></i>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="tablebottom">
                    <!-- 分页 -->
                    <el-pagination class="pagination" background @size-change="getProjectList(true)"
                        @current-change="() => getProjectList()" :current-page.sync="pagination.currentPage"
                        :page-sizes="[10, 15, 20, 30, 50]" :page-size.sync="pagination.pagesize"
                        layout="slot, sizes, total, pager, prev, next, jumper" :total="pagination.total"
                        popper-class="select-page">
                        <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
                    </el-pagination>
                </div>
            </div>
        </div>
        <div v-if="$store.state.device.UsrPermission == 2" class="debugInfo">
            <div class="deviceHeader">
                <div class="deviceHeaderLeft">
                    <div class="closepage" @click="goList"></div>
                    <div v-if="this.formData.roleId">{{ $t('account.Edit_role') }}</div>
                    <div v-else>{{ $t('account.Add_role') }}</div>
                </div>
            </div>
            <div class="deviceBody">
                <div class="titleTab">
                    <el-form :model="formData" :rules="formRules" ref="formData" size="small" :inline="true" class="gridbox">
                        <el-form-item :label="$t('account.Role_name')" prop="roleName">
                            <el-input v-model="formData.roleName"  maxlength="20" :show-word-limit="true" :placeholder="$t('account.Ple_role3')" clearable></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('account.Role_des')" prop="desc" style="margin-left: 20px;display: flex;align-items: center;">
                            <el-input type="textarea" v-model="formData.desc" maxlength="50" :show-word-limit="true"  :placeholder="$t('account.Ple_role4')"></el-input>
                        </el-form-item>
                    </el-form>
                    <ul class="tabBox" v-if="$store.state.user.uidExtra=='43955'||$store.state.user.uidExtra=='57791'">
                        <li v-for="(item, index) in tabData" :key="item.name" :class="{ active: !(index - menuIndex) }"
                        @click="tabActive(index)" >{{ item.name }}</li>
                    </ul>
                </div>
                <div class="roleTable" v-if="menuIndex == '1'">
                    <div class="header">
                        <div style="width:15%" class="eb-color-onprimary">{{ $t('account.module') }}</div>
                        <div style="width:15%" class="eb-color-onprimary">{{ $t('account.First_page') }}</div>
                        <div style="width:15%" class="eb-color-onprimary">{{ $t('account.Secondary_page') }}</div>
                        <div style="width:55%" class="eb-color-onprimary">{{ $t('account.Function_points') }}</div>
                    </div>
                    <template v-for="(item, index) in permissionsList">
                        <div style="font-size: 16px;" :key="item.id"  class="content-list"  :class="index % 2 == 0 ? 'eb-bgc-background' : 'eb-bgc-surface'">
                            <div style="width:15%;text-align: center;align-self: center;">
                                <!-- 一级 -->
                                <div
                                    class="eb-checkbox">{{ $lang.currentLang=='zh_CN'?item.controlNameCn:item.controlNameUs }}</div>
                            </div>
                            <div style="width:55%;text-align: center;align-self: center;" v-if="item.first_menus.length==0">
                                <div style="min-height: 50px;padding: 10px;display: flex;align-items: center;justify-content: flex-start;flex-wrap: wrap;">
                                    <!-- 按钮 -->
                                    <el-checkbox class="eb-checkbox"  v-for="first_button in item.dataRole"
                                        v-model="first_button.isCheck" :key="first_button.id"
                                        @change="first_button.isCheck?item.isCheck=true:''">{{ $lang.currentLang=='zh_CN'?first_button.controlNameCn:first_button.controlNameUs }}</el-checkbox>
                                </div>
                            </div>
                            <div style="width:85%;text-align: center;align-self: center;" v-else>
                                <div v-for="(firstItem, firstdex) in item.first_menus" :key="firstItem.id"
                                    style="width:100%;display: flex;justify-content: space-between;">
                                    <div style="width:17.64705882352941%;min-height: 50px;display: flex;align-items: center;justify-content: center;">
                                        <!-- 二级 -->
                                        <div 
                                            class="eb-checkbox">{{ $lang.currentLang=='zh_CN'?firstItem.controlNameCn:firstItem.controlNameUs }}</div>
                                    </div>
                                    <div style="width:64.470588235294118%;text-align: center;align-self: center;" v-if="firstItem.second_menus.length==0">
                                        <div style="min-height: 50px;padding: 10px;display: flex;align-items: center;justify-content: flex-start;flex-wrap: wrap;">
                                            <!-- 按钮 -->
                                            <el-checkbox class="eb-checkbox"  v-for="(second_button, buttondex) in firstItem.dataRole"
                                                    v-model="second_button.isCheck" :key="second_button.id"
                                                    @change="handleCheckDataRole1Change($event, index, firstdex, buttondex)">{{ $lang.currentLang=='zh_CN'?second_button.controlNameCn:second_button.controlNameUs }}</el-checkbox>
                                        </div>
                                    </div>
                                    <div style="width:82.35294117647059%;text-align: center;align-self: center;" v-else>
                                        <div v-for="(secondItem, seconddex) in firstItem.second_menus" :key="secondItem.id"
                                            style="width:100%;display: flex;justify-content: space-between;">
                                            <div style="width:21.42857142857143%;min-height: 50px;display: flex;align-items: center;justify-content: center;">
                                                <!-- 三级 -->
                                                <div 
                                                    class="eb-checkbox">{{ $lang.currentLang=='zh_CN'?secondItem.controlNameCn:secondItem.controlNameUs }}</div>
                                            </div>
                                            <div style="width:78.57142857142857%;min-height: 50px;padding: 10px;display: flex;align-items: center;justify-content: flex-start;flex-wrap: wrap;">
                                                <!-- 按钮 -->
                                                <el-checkbox class="eb-checkbox" v-for="(three_button, three_buttondex)  in secondItem.dataRole"
                                                    v-model="three_button.isCheck" :key="three_button.id"
                                                    @change="handleCheckDataRoleChange($event, index, firstdex, seconddex, three_buttondex)">{{ $lang.currentLang=='zh_CN'?three_button.controlNameCn:three_button.controlNameUs }}</el-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="roleTable" v-else>
                    <div class="header">
                        <div style="width:15%" class="eb-color-onprimary">{{ $t('account.module') }}</div>
                        <div style="width:15%" class="eb-color-onprimary">{{ $t('account.First_page') }}</div>
                        <div style="width:15%" class="eb-color-onprimary">{{ $t('account.Secondary_page') }}</div>
                        <div style="width:55%" class="eb-color-onprimary">{{ $t('account.Function_points') }}</div>
                    </div>
                    <template v-for="(item, index) in permissionsList">
                        <div :key="item.id"  class="content-list"  :class="index % 2 == 0 ? 'eb-bgc-background' : 'eb-bgc-surface'">
                            <div style="width:15%;text-align: center;align-self: center;">
                                <!-- 一级 -->
                                <el-checkbox v-model="item.isCheck" @change="handleCheckAllChange($event, index)"
                                    class="eb-checkbox">{{ $lang.currentLang=='zh_CN'?item.controlNameCn:item.controlNameUs }}</el-checkbox>
                            </div>
                            <div style="width:55%;text-align: center;align-self: center;" v-if="item.first_menus.length==0">
                                <div style="min-height: 50px;padding: 10px;display: flex;align-items: center;justify-content: flex-start;flex-wrap: wrap;">
                                    <!-- 按钮 -->
                                    <el-checkbox class="eb-checkbox"  v-for="first_button in item.buttons"
                                        v-model="first_button.isCheck" :key="first_button.id"
                                        @change="first_button.isCheck?item.isCheck=true:''">{{ $lang.currentLang=='zh_CN'?first_button.controlNameCn:first_button.controlNameUs }}</el-checkbox>
                                </div>
                            </div>
                            <div style="width:85%;text-align: center;align-self: center;" v-else>
                                <div v-for="(firstItem, firstdex) in item.first_menus" :key="firstItem.id"
                                    style="width:100%;display: flex;justify-content: space-between;">
                                    <div style="width:17.64705882352941%;min-height: 50px;display: flex;align-items: center;justify-content: center;">
                                        <!-- 二级 -->
                                        <el-checkbox v-model="firstItem.isCheck"
                                            @change="handleCheckFirstAllChange($event, index, firstdex)"
                                            class="eb-checkbox">{{ $lang.currentLang=='zh_CN'?firstItem.controlNameCn:firstItem.controlNameUs }}</el-checkbox>
                                    </div>
                                    <div style="width:64.470588235294118%;text-align: center;align-self: center;" v-if="firstItem.second_menus.length==0">
                                        <div style="min-height: 50px;padding: 10px;display: flex;align-items: center;justify-content: flex-start;flex-wrap: wrap;">
                                            <!-- 按钮 -->
                                            <el-checkbox class="eb-checkbox"  v-for="second_button in firstItem.buttons"
                                                    v-model="second_button.isCheck" :key="second_button.id"
                                                    @change="handleCheckButton1Change($event, index, firstdex)">{{ $lang.currentLang=='zh_CN'?second_button.controlNameCn:second_button.controlNameUs }}</el-checkbox>
                                        </div>
                                    </div>
                                    <div style="width:82.35294117647059%;text-align: center;align-self: center;" v-else>
                                        <div v-for="(secondItem, seconddex) in firstItem.second_menus" :key="secondItem.id"
                                            style="width:100%;display: flex;justify-content: space-between;">
                                            <div style="width:21.42857142857143%;min-height: 50px;display: flex;align-items: center;justify-content: center;">
                                                <!-- 三级 -->
                                                <el-checkbox v-model="secondItem.isCheck"
                                                    @change="handleCheckThreeChange($event, index,firstdex, seconddex)"
                                                    class="eb-checkbox">{{ $lang.currentLang=='zh_CN'?secondItem.controlNameCn:secondItem.controlNameUs }}</el-checkbox>
                                            </div>
                                            <div style="width:78.57142857142857%;min-height: 50px;padding: 10px;display: flex;align-items: center;justify-content: flex-start;flex-wrap: wrap;">
                                                <!-- 按钮 -->
                                                <el-checkbox class="eb-checkbox" v-for="three_button  in secondItem.buttons"
                                                    v-model="three_button.isCheck" :key="three_button.id"
                                                    @change="handleCheckButtonChange($event, index, firstdex, seconddex)">{{ $lang.currentLang=='zh_CN'?three_button.controlNameCn:three_button.controlNameUs }}</el-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="footButton">
                <button class="backbtn" @click="goList">{{ $t('account.cancel') }}</button>
                <button class="button-solid" @click="subPermission">{{$t('account.confirm') }}</button>
            </div>
        </div>
        <!-- 删除角色 -->
        <role-dialog :title="$t('account.Remove_role')" :visible.sync="deleteRoleDialog" :width="'450px'"
            :class="{ 'showDialog': deleteRoleDialog, 'hideDialog': !deleteRoleDialog }" noFooter>
            <div class="content_tishi" slot="content">
                <div class="tital">
                    <!-- <i class="iconfont icon-gantanhao"></i> -->
                    <span class="contentdelete" style="width:100%;text-align:left;">{{ $t('account.confirmDelete')
                        }}</span>
                </div>
                <div class="disabledescr">
                    <span style="width:100%;text-align:left;margin-top:28px;color:rgba(255, 255, 255, 0.7);">{{
                        $t('account.notRecovered') }}</span>
                </div>
                <!-- {{$t('account.confirmDelete')}}</div> -->
                <div class="deletfotter" style="text-align:right;margin-top:28px;">
                    <button type="button" class="btn btn-dark" style="margin-right:10px;" @click="deleteRoleSub">{{
                        $t('account.confirm') }}</button>
                    <button type="button" class="btn btn-light" @click="deleteRoleDialog = false">{{ $t('account.cancel') }}</button>
                </div>
            </div>
        </role-dialog>
    </div>
</template>
<script>
import roleDialog from "@/components/dialognew";
import _ from "lodash"
export default {
    components: {
        roleDialog,
    },
    data() {
        return {
            //左侧切换栏数据
            tabData: [
                {
                name: this.$t("account.functionalPermission")
                },
                {
                name: this.$t("account.dataPermission")
                }
            ],
            //用户与分组切换
            menuIndex: 0,
            params:"",
            deleteRoleDialog: false,
            formData: {
                roleName: "",
                desc: "",
            },
            formRules: {
                roleName: [
                {
                  required: true,
                  message: this.$t("account.Ple_role3"),
                  trigger: "blur"
                }
              ],
            },
            permissionsList: [],
            // 项目列表分页加载
            pagination: {
                currentPage: 1,
                pagesize: 15,
                total: 0,
            },
            // 项目加载加载
            loadingAuthority: false,
            // 搜索弹出
            showSearch: false,
            // 搜索
            search: {
                roleName: "",
            },
            // 项目列表
            proList: [],
        };
    },
    watch: {},
    created() {
        this.getProjectList();
    },
    methods: {
        getProjectList(reset) {
            if (reset) this.pagination.currentPage = 1;
            let param = {
                page: this.pagination.currentPage - 1,
                pagesize: this.pagination.pagesize,
                timezone:-(new Date().getTimezoneOffset() / 60),
                devtype: 2304,
                roleName: this.search.roleName,
            };
            this.loadingAuthority = true;
            this.$request.get("queryDistRoleInfo", param).then(res => {
                if (res.err == 0) {
                    // 赋值
                    this.proList = res.dat.collUserPermissions;
                    this.pagination.total = res.dat.total;
                } else {
                    this.proList = [];
                    this.pagination.total = 0;
                }
                this.loadingAuthority = false;
            });
        },
        getManuPermissions() {
            this.$request.get("queryDistPermissionTree").then(res => {
                if (res.err == 0) {
                    this.permissionsList = res.dat
                } else {
                    this.permissionsList = []
                }
            });
        },
        deteleRole(info) {
            this.params = info;
            this.deleteRoleDialog = true
        },
        // 删除角色提交
        deleteRoleSub() {
            let param = {
                roleId:this.params.roleId,
              }
            this.$request
              .get("delDistRole", param)
              .then(res => {
                if (res.err == 0) {
                    this.getProjectList();
                } else {
                    this.$message.error(this.$t(`errCode.${res.err}`));
                }
                this.deleteRoleDialog = false
              });
        },
        addRolePermission() {
            Object.keys(this.formData).forEach(
              key => (this.formData[key] = "")
            );
            this.permissionsList = []
            this.$store.commit("saveUsrPermission", 2)
            this.getManuPermissions()
        },
        goList() {
            this.$store.commit("saveUsrPermission", 1)
            this.getProjectList();
        },
        editRole(info) {
            // this.$store.commit("saveUsrPermission", 2)
            this.formData={...info}
            // this.permissionsList = info.item
            this.$request.get("queryRoleUpdateInfo", {roleId:this.formData.roleId}).then(res => {
                if (res.err == 0) {
                    // 赋值
                    this.$store.commit("saveUsrPermission", 2)
                    this.permissionsList = res.dat
                } else {
                    this.permissionsList = []
                }
            });
        },
        subPermission() {
            this.$refs.formData.validate(valid => {
            if (!valid) return false;
            let params = {
                roleName:this.formData.roleName,
                desc:this.formData.desc,
                roleId:this.formData.roleId?this.formData.roleId:"",
                item:this.permissionsList,
              }
            if (this.permissionsList.every(item => item.isCheck == false))
             return this.$message.warning(this.$t("account.Ple_role5"));
            this.$request
              .RolePostPermissions(this.formData.roleId? "editDistRolePost" : "addDistRolePost", params)
              .then(res => {
                if (res.err == 0) {
                    this.goList()
                }else if(res.err == 527){
                    this.$message.error(this.$t("account.Ple_role6"));
                }else if(res.err == 8){
                    this.$message.error(this.$t("account.edit_limit_UserTypeDataPermission"));
                } else {
                    this.$message.error(this.$t(`errCode.${res.err}`));
                }
              });
          });
        },
        handleCheckAllChange(val, index) {
            if (this.permissionsList[index].first_menus.length) {
              this.permissionsList[index].first_menus.forEach(item => {
               item.isCheck = val;
               if (item.second_menus.length){
                   item.second_menus.forEach(firstItem => {
                   firstItem.isCheck = val;
                   if (firstItem.buttons.length > 0) {
                    firstItem.buttons.forEach(sonItem => {
                      sonItem.isCheck = val;
                    });
                    }
                  });
               }else{
                if (item.buttons.length > 0) {
                    item.buttons.forEach(sonItem => {
                   sonItem.isCheck = val;
                });
                }
               }
             });
           }else{
            if (this.permissionsList[index].buttons.length > 0) {
                this.permissionsList[index].buttons.forEach(sonItem => {
                   sonItem.isCheck = val;
                });
             }
           }
        },
        handleCheckFirstAllChange(val, index, sindex) {
            if (_.find(this.permissionsList[index].first_menus, 'isCheck')) {
               this.permissionsList[index].isCheck = true
             }else{
                this.permissionsList[index].isCheck = false
             }
            this.permissionsList[index].first_menus[sindex].second_menus.forEach(item => {
              item.isCheck = val;
              if (item.buttons.length > 0) {
                item.buttons.forEach(sonItem => {
                   sonItem.isCheck = val;
                 });
                }
            });
            this.permissionsList[index].first_menus[sindex].buttons.forEach(item => {
              item.isCheck = val;
            });
        },
        handleCheckDataRole1Change(val, index, sindex,buttondex){
            if (val) {
                this.permissionsList[index].first_menus[sindex].dataRole.forEach((item, parentIndex) => {
                    if (parentIndex!=buttondex) {
                        item.isCheck = false
                    }
                })
             }
        },
        handleCheckDataRoleChange(val, index, sindex,secondex,three_buttondex) {
            if (val) {
                 this.permissionsList[index].first_menus[sindex].second_menus[secondex].dataRole.forEach((item, parentIndex) => {
                     if (parentIndex!=three_buttondex) {
                         item.isCheck = false
                     }
                 })
             }
        },
        handleCheckButton1Change(val, index, sindex){
            if (val) {
               this.permissionsList[index].isCheck = true
               this.permissionsList[index].first_menus[sindex].isCheck = true
             }
        },
        handleCheckButtonChange(val, index, sindex,secondex) {
             if (val) {
               this.permissionsList[index].isCheck = true
               this.permissionsList[index].first_menus[sindex].isCheck = true
               this.permissionsList[index].first_menus[sindex].second_menus[secondex].isCheck = true
             }
        },
        handleCheckThreeChange(val, index, sindex,secondex) {
            if (_.find(this.permissionsList[index].first_menus[sindex].second_menus, 'isCheck')) {
               this.permissionsList[index].isCheck = true
               this.permissionsList[index].first_menus[sindex].isCheck = true
             }else{
                this.permissionsList[index].first_menus[sindex].isCheck = false
                if(!_.find(this.permissionsList[index].first_menus, 'isCheck')){
                    this.permissionsList[index].isCheck = false
                }
             }
             this.permissionsList[index].first_menus[sindex].second_menus[secondex].buttons.forEach(item => {
              item.isCheck = val;
            });
        },
        // 关闭搜索框
        closeSearch() {
            this.showSearch = false;
            this.search.roleName = '';
            this.getProjectList();
        },
        showSearchBtn() {
            this.showSearch = true;
            this.$nextTick(() => {
                this.$refs.iptFocus.focus();
            })
        },
        tabActive (index) {
            this.menuIndex = index;
        },
    }
};
</script>
<style lang="less" scoped>
@import url("../../../assets/css/mixin.less");

.dataloggerManage {
    display: flex;
    flex: 1;
    flex-direction: column;
    margin: 20px;
    // background-color: rgb(34, 45, 53);
    overflow: auto;

    .redirect {
        color: @primaryTextColor;
    }

    .btn {
        padding: 6px 12px;
        border-radius: 6px;
        font-size: 14px;
        cursor: pointer;
    }

    .btn-disable {
        color: rgba(242, 242, 242, 0.5);
        background: rgba(43, 56, 66, 1);
        cursor: not-allowed;
    }

    .btn-dark {
        background: @primaryTextColor;
        color: rgba(34, 45, 53, 1);
        border: none;
    }

    .btn-light {
        background: transparent;
        color: @primaryTextColor;
        border: 1px solid @primaryTextColor;
    }

    .ico-recharge {
        background: url(../../../assets/img/general/Icon_Recharge.png);
    }

    .ico {
        display: inline-block;
        width: 20px;
        height: 20px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        vertical-align: middle;
    }

    .section {
        display: flex;
        flex: 1;
        padding: 0px;
        flex-direction: column;
        border-radius: 0px;
        border: none;
        background: rgb(34, 45, 53);
        position: relative;
        overflow: hidden;

        /deep/.el-icon-loading {
            font-size: 28px;
        }

        .search {
            margin: 0px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            background: rgb(34, 45, 53);

            .search-label {
                display: inline-block;
                color: #ffffff;
                font-weight: bold;
                line-height: 48px;
                font-size: 14px;
                padding-left: 16px;
            }

            /deep/.el-select {
                // width: 100px;
                border-right: 1px solid #738089;
            }

            /deep/.el-select:hover {
                background: @primaryColorTransparency30;
            }

            /deep/.el-input {
                width: 100%;
                text-align: center;
            }

            /deep/.el-input__inner {
                background: transparent;
                border: none;
                height: 48px;
                line-height: 48px;
                color: #ffffff;
                padding: 0 16px;
            }

            /deep/.el-input__suffix {
                right: 0px;
            }

            .button {
                height: 48px;
                line-height: 48px;
                padding: 0 25px;
                margin-top: 0px;
                color: @primaryTextColor;
                background: transparent;
                border: none;
            }

            .search-alert {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 48px;
                z-index: 1;
                background: rgb(34, 45, 53);
                display: flex;
                align-items: center;
                justify-content: space-between;
                .searchDiv {
                  position: absolute;
                  top: 0;
                  // left: 0;
                  right: 0;
                  width: 400px;
                  height: 48px;
                  z-index: 2;
                  background: rgb(34, 45, 53);
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                }
        
                .searchAll {
        
                  // display: flex;
                  // align-items: center;
                  // justify-content: flex-end;
                  /deep/.el-input__inner {
                    width: 220px;
                    padding-left: 10px;
                  }
                }
        
                .search-device {
                  display: inline-block;
                  line-height: 48px;
                  padding: 0 15px;
                  font-size: 14px;
                  background: #202D35;
                  color: #33FFB6;
                  cursor: pointer;
        
                  &:hover {
                    background: @primaryColorTransparency30;
                    color: rgb(255, 255, 255, 1);
                  }
                }
        
                .search-hide {
                    display: inline-block;
                    // position: absolute;
                    // right: -58px;
                    line-height: 48px;
                    padding: 0 15px;
                    font-size: 14px;
                    background: #202D35;
                    color: #7B8395;
                    border-left: 1px solid #7B8395;
                    cursor: pointer;

                    &:hover {
                        background: @primaryColorTransparency30;
                        color: rgb(255, 255, 255, 1);
                    }
                }

                /deep/.el-input {
                    flex: 1;
                }

                /deep/.el-input .el-input__clear {
                    width: 48px;
                    color: #7B8395;
                }

                /deep/.el-input .el-input__clear:hover {
                    background: @primaryColorTransparency30;
                    color: rgb(255, 255, 255, 1);
                }

                /deep/.el-input .el-input__inner,
                /deep/.el-input .el-input__inner:hover {
                    height: 48px;
                    border-radius: 0px;
                    border: none;
                    background: #202D35;
                    color: #ffffff;
                    padding-left: 40px;
                }

                /deep/.el-input__prefix {
                    left: 0px;
                }

                /deep/.el-input__icon {
                    width: 40px;
                }

                /deep/.el-input__suffix {
                    right: 0px;
                }

                /deep/.el-input__suffix:hover {
                    background: @primaryColorTransparency30;
                    color: rgb(255, 255, 255, 1);
                }

                /deep/.el-icon-circle-close:before {
                    content: 'X'
                }

                /deep/.el-input:not(:last-child) {
                    margin-right: 0px;
                }
            }

            .button-upload {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 114px;
                height: 48px;
                line-height: 16px;
                background: @primaryTextColor;
                color: rgb(34, 45, 53);
                font-size: 14px;
                border-radius: 0px;
                border: none;
                cursor: pointer;
            }
        }

        .tableloding {

            // 加载数据时遮罩
            /deep/.el-loading-mask {
                background-color: rgb(34, 45, 53, .5);
            }

            /deep/.el-loading-spinner i {
                color: @primaryTextColor;
            }
        }

        .tablemain {
            border: none;
            background-color: rgb(34, 45, 53);

            .operation i {
                color: @primaryTextColor;
            }

            // 表格右侧边线
            // /deep/.el-table--border::after, 
            // /deep/.el-table--group::after {
            //   width: 0px;
            // }
            /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
                width: 16px;
                height: 16px;
                background: transparent;
                border: 1px solid rgb(180, 184, 193);
                border-radius: 0px;
            }

            /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
                top: 2px;
                left: 5px;
            }

            /deep/.el-table__header th {
                height: 48px;
            }

            /deep/.el-table__header th.is-leaf {
                border-color: rgba(198, 209, 221, 0.5);
                // border-bottom: none;
            }

            /deep/.el-table__header th>.cell {
                font-weight: normal;
                font-size: 12px;
            }

            /deep/.el-table__body tr,
            /deep/.el-table__body td {
                background-color: rgb(34, 45, 53);
                color: #ffffff;
                border-color: rgba(198, 209, 221, 0.5);
            }

            /deep/.el-table__body td.el-table-column--selection {
                background-color: rgb(65, 80, 90);
                color: #ffffff;
            }

            /deep/.el-table__body .cell.el-tooltip {
                font-size: 14px;
            }

            /deep/.el-table__fixed-right::before,
            /deep/.el-table__fixed::before {
                display: none;
            }

            ::-webkit-scrollbar {
                width: 6px;
                height: 6px;
                background-color: #222d35;
            }

            // 关于复选框
            /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
                background: @primaryTextColor;
                border: 1px solid @primaryTextColor;
            }

            /deep/.el-checkbox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
                background: @primaryTextColor;
                border: 1px solid @primaryTextColor;
            }

            // 关于头部右侧空白
            /deep/.el-table__fixed-right-patch {
                background-color: rgb(65, 80, 90);
                border-bottom: none;
            }

            /deep/th.gutter {
                background-color: rgb(65, 80, 90);
            }
        }

        .tablebottom {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            border-top: 1px solid rgba(198, 209, 221, 0.5);

            // 分页
            .pagination {
                line-height: 48px;
                height: 48px;
                padding: 0;
                margin: 0;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin-right: 16px;

                /deep/.el-pager li {
                    vertical-align: middle;
                }

                /deep/.el-select .el-input {
                    width: 90px;
                    margin: 0px;
                }

                /deep/.el-input .el-input__inner {
                    background-color: #202D35;
                    color: #ffffff;
                }

                /deep/.el-input__suffix {
                    right: 10px;
                }

                /deep/.el-pagination__sizes {
                    margin: 0px;
                    height: 48px;
                    line-height: 48px;
                }

                /deep/.el-pagination__total {
                    color: #fff;
                    padding-left: 15px;
                    border-left: 1px solid #7B8395;
                    height: 48px;
                    line-height: 48px;
                }

                /deep/.el-pager li:not(.disabled).active {
                    // background: #15C491;
                    // color: #ffffff;
                    background-color: #2B3842;
                    color: #15C491;
                }

                // li:not(.disabled):not(.active):hover
                /deep/.el-pager li:not(.disabled):hover {
                    background-color: @primaryColorTransparency30;
                    color: rgba(255, 255, 255, 1);
                }

                /deep/.el-pager li {
                    background-color: #2B3842;
                    color: #7B8395;
                }

                // 页条数下拉
                /deep/.el-select .el-input .el-input__inner {
                    border: none;
                    height: 48px;
                    line-height: 48px;
                    border-radius: 0px;
                }

                /deep/.el-select .el-input .el-input__inner:hover {
                    background: @primaryColorTransparency30;
                }

                // 跳页
                /deep/.el-pagination__jump {
                    color: #ffffff;
                }

                /deep/.el-pagination__editor {
                    padding: 0px 6px;
                }

                /deep/.el-pagination__editor.el-input .el-input__inner {
                    border: 1px solid #7B8395;
                }
            }

            // 分页前后按钮
            /deep/.el-pagination.is-background .btn-next,
            /deep/.el-pagination.is-background .btn-prev {
                background-color: #2B3842;
                color: #7B8395;
            }

            /deep/.el-pagination.is-background .btn-next:hover,
            /deep/.el-pagination.is-background .btn-prev:hover {
                background-color: @primaryColorTransparency30;
                color: rgba(255, 255, 255, 1);
            }

            /deep/.el-pagination.is-background button[disabled],
            /deep/.el-pagination.is-background button[disabled]:hover {
                background-color: #2B3842;
                color: #7B8395;
            }
        }
    }

    ::-webkit-scrollbar {
        width: 0px;
        height: 0px;
        background-color: #222d35;
    }

    .debugInfo {
        display: flex;
        flex: 1;
        flex-direction: column;
        height: 100%;

        .deviceHeader {
            display: flex;
            font-size: 20px;
            color: #ffffff;
            justify-content: space-between;
            align-items: center;
            background-color: #222d35;

            .deviceHeaderLeft {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                div:last-child {
                    padding-left: 30px;
                    font-weight: 700;
                }

                .closepage {
                    display: inline-block;
                    background-color: #23323D;
                    width: 60px;
                    height: 56px;
                    background-image: url('../../../assets/img/general/arrow_left.png');
                    background-size: 24px 24px;
                    background-repeat: no-repeat;
                    background-position: center;
                    cursor: pointer;
                }
            }
        }

        .deviceBody {
            background-color: #222d35;
            margin-top: 10px;
            padding: 20px;
            flex: 1;
            overflow-y: auto;
            //   padding:20px 500px 20px 110px ;
            color: #fff;
            .titleTab{
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            //切换盒子
            .tabBox {
                // max-width: 100%;
                display: flex;
                height: 30px;
                border: 1px solid @primaryTextColor;
                margin-bottom: 20px;
                border-radius: 8px;
                margin-right: 10px;

                .active {
                    background-color: @primaryTextColor;
                    color: #222d35;
                    border-radius: 6px;
                }

                li {
                    cursor: pointer;
                    display: inline-block;
                    // max-width: 50%;
                    color: #70818c;
                    // background-color: @primaryTextColor;
                    text-align: center;
                    line-height: 30px;
                    font-size: 15px;
                    height: 30px;
                    padding: 0 30px;
                    white-space: nowrap;
                    // overflow: hidden;
                }
            }
            .gridbox {
                display: flex;
                justify-content: flex-start;
                align-items: center;
            }

            .roleTable {
                display: flex;
                flex-direction: column;
                font-size: 14px;

                .header {
                    height: 40px;
                    line-height: 40px;
                    display: flex;
                    text-align: center;
                    background-color: #676e72 !important;
                }

                .content-list {
                    min-height: 50px;
                    display: flex;
                    justify-content: space-between;
                    /deep/.el-checkbox .el-checkbox__label {
                            width: auto;
                            min-width: 100px !important;
                            max-width: 280px !important;
                            white-space: normal;
                            word-break: break-all;
                            color: #fff;
                            line-height: 32px;
                            height: 32px;
                        }
                }

                /deep/.el-checkbox.is-checked .el-checkbox__input.is-checked .el-checkbox__inner {
                    // background-color: #4579c2;
                    background-color: @primaryTextColor;
                    border-color: #ebebeb;

                }

                /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner:hover {
                    background: transparent;
                    border: 1px solid #ebebeb;
                }

                .eb-bgc-surface {
                    background: #3c464d !important;
                    // background: linear-gradient(0deg, rgba(0, 136, 96, .05), rgba(0, 136, 96, .05)), #94bcd9 !important;
                }

                .eb-bgc-background {
                    background: #434c53 !important;
                    // background: linear-gradient(0deg, rgba(0, 136, 96, .05), rgba(0, 136, 96, .05)), #789fbb !important;
                }
            }

        }

        .footButton {
            background: #222d35;
            height: 60px;
            padding: 0 20px;
            // border-top: 1px solid @borderColor;
            display: flex;
            justify-content: center;
            align-items: center;

            .backbtn {
                font-size: 14px;
                padding: 6px 10px;
                border-radius: 6px;
                cursor: pointer;
                margin: 0 6px;
                background: #222d35;
                color: @primaryTextColor;
                border: 1px solid @primaryTextColor;
            }

            .button {
                font-size: 14px;
                padding: 6px 10px;
                border-radius: 6px;
                // min-width: 100px;
                cursor: pointer;
                margin: 0 6px;
                background-color: @primaryTextColor;
                color: #202D35;
                border: none;
            }

            .button-hollow {
                border-radius: 5px;
                .sc(14px, #666);
                border-color: #ddd;
                .button;

                &:hover {
                    background: #f8f9fa;
                }
            }

            .button-solid {
                .button;
            }
        }

        /deep/.el-input .el-input__inner {
            color: #fff;
            width: 300px;
            background: #2b3842;
            border-color: #a3a9b5;
        }

        /deep/.el-textarea .el-textarea__inner {
            color: #fff;
            width: 300px;
            background: #2b3842;
            border-color: #a3a9b5;
        }
    }

    /deep/.el-form-item__label {
        color: #fff;
    }

    //   .grid {
    //     grid-row-gap: 28px;
    //     padding-bottom: 0px;
    //   }
}
</style>
<style lang="less">
.tablemain.el-table--border::after {
    display: none;
}
</style>